import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#00ACC1',
        secondary: '#1E88E5',
        background: '#ffffff',
        pinkKonect: '#E22D86',
        blueKonect: '#4CACB9'
      },
    }
  }
}

export default new Vuetify(opts)
